<template>
    <div class="">
        <router-view></router-view>
    </div>
</template>